import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../app-constants";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentMainContent,
  contentTitle,
  content,
  Link,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div className="main-title-content">
            <p dangerouslySetInnerHTML={{ __html: contentMainContent }} />
          </div>
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
            {/* <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              {{ __html: Link }}
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden b2b-portal-seamless">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Discovery & Analysis"
          contentMainTitle="Seamless <span>B2B Portal Development Solutions</span> – Fast, Efficient, & Hassle-Free</span>"
          contentMainContent="Our B2B portal development process is designed to deliver powerful, custom-built solutions that align with your business objectives. We focus on a lean and frictionless approach, ensuring every step is streamlined, so your portal development journey is as smooth as possible."
          icon={HomeUpdatedonedev}
          contentTitle="Discovery & Analysis"
          content="We assess your business workflows, integrations, and objectives to define portal requirements accurately."
          // Link="Talk to Our Experts"
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="Solution Architecture"
          contentMainTitle="Seamless <span>B2B Portal Development Solutions</span> – Fast, Efficient, & Hassle-Free</span>"
          contentMainContent="Our B2B portal development process is designed to deliver powerful, custom-built solutions that align with your business objectives. We focus on a lean and frictionless approach, ensuring every step is streamlined, so your portal development journey is as smooth as possible."
          icon={HomeUpdatedtwodev}
          contentTitle="Solution Architecture"
          content="We design a secure, scalable architecture that integrates with your existing enterprise systems seamlessly."
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="UX/UI Design"
          contentMainTitle="Seamless <span>B2B Portal Development Solutions</span> – Fast, Efficient, & Hassle-Free</span>"
          contentMainContent="Our B2B portal development process is designed to deliver powerful, custom-built solutions that align with your business objectives. We focus on a lean and frictionless approach, ensuring every step is streamlined, so your portal development journey is as smooth as possible."
          icon={HomeUpdatedthreedev}
          contentTitle="UX/UI Design"
          content="We create intuitive interfaces and streamlined user flows, enhancing usability and driving user engagement."
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="Development & Integration"
          contentMainTitle="Seamless <span>B2B Portal Development Solutions</span> – Fast, Efficient, & Hassle-Free</span>"
          contentMainContent="Our B2B portal development process is designed to deliver powerful, custom-built solutions that align with your business objectives. We focus on a lean and frictionless approach, ensuring every step is streamlined, so your portal development journey is as smooth as possible."
          icon={HomeUpdatedfourdev}
          contentTitle="Development & Integration"
          content="We develop the portal using modern frameworks and integrate APIs to ensure smooth system interoperability."
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Quality Assurance"
          contentMainTitle="Seamless <span>B2B Portal Development Solutions</span> – Fast, Efficient, & Hassle-Free</span>"
          contentMainContent="Our B2B portal development process is designed to deliver powerful, custom-built solutions that align with your business objectives. We focus on a lean and frictionless approach, ensuring every step is streamlined, so your portal development journey is as smooth as possible."
          icon={HomeUpdatedfivedev}
          contentTitle="Quality Assurance"
          content="We perform end-to-end testing for performance, functionality, and security, ensuring flawless execution."
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        <AccordionItem
          title="Deployment & Onboarding"
          contentMainTitle="Seamless <span>B2B Portal Development Solutions</span> – Fast, Efficient, & Hassle-Free</span>"
          contentMainContent="Our B2B portal development process is designed to deliver powerful, custom-built solutions that align with your business objectives. We focus on a lean and frictionless approach, ensuring every step is streamlined, so your portal development journey is as smooth as possible."
          icon={HomeUpdatedsixdev}
          contentTitle="Deployment & Onboarding"
          content="We launch the portal, migrate data, and provide comprehensive training for a smooth transition and adoption."
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        />
        {/* <AccordionItem
          title="Support & Expand"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedsevendev}
          contentTitle="Support & Expand"
          content="We provide support and maintenance services for updating and optimizing your application further in use. We also work to expand and enhance your application, adding new features and functionalities as the business expands."
          isOpen={activeIndex === 6}
          onToggle={() => handleToggle(6)}
        /> */}
        {/* <AccordionItem
          title="Continuous Support & Optimization"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedeightdev}
          contentTitle="Continuous Support & Optimization"
          content="Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation"
          isOpen={activeIndex === 7}
          onToggle={() => handleToggle(7)}
        /> */}
      </div>
    </section>
  );
}

export default DiscoveryAcc;
